module.exports = __webpack_public_path__ + "static/media/bike.a688caab.png";